import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';
import { TASK_TYPE_DYNAMIC_FIELD_TYPE } from 'store/system/actions';

const initialState = [];

const taskTypeDynamicFieldReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case TASK_TYPE_DYNAMIC_FIELD_TYPE.GET_TASK_TYPE_DYNAMIC_FIELD_VARIABLES:
        return payload || state;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default taskTypeDynamicFieldReducer;
